import { BlueberrySizeDataModel } from '../types';

/**
 * Adds counts of all the colors for one bucket
 * @param data
 * @returns
 */
export const getBucketTotal = (data: BlueberrySizeDataModel) => {
  // FIXME with conditional colors for color 2.0
  return (
    Math.round(data.green) +
    Math.round(data.yellow) +
    Math.round(data.purple) +
    Math.round(data.blue)
  );
};

/**
 * Round and format a fractional decimal as a percentage (ex. 0.5437 -> 54.4%)
 * @param decimal - Percentage expressed as a decimal number between 0 and 1
 * @param precision - Number of decimal points in final string
 * @returns
 */
export const decimalToRoundedPercentageString = (
  decimal: number,
  precision: number
) => {
  const mult = Math.pow(10, precision || 0);
  return `${(Math.round(decimal * 100 * mult) / mult).toFixed(precision)}%`;
};
